var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Node',{staticClass:"start-node",attrs:{"node-id":_vm.nodeId,"show-node-name":false,"show-node-options":false}})}
var staticRenderFns = []

export { render, staticRenderFns }